import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { store } from "../../store";
import { toast } from "react-toastify";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import DownloadIcon from "SVGS/DownloadIcon";
import { NO_DATA_FOR_EXPORT } from "Common/ToastConstants";
const ExportExcel = (props) => {
  const [loader, setLoader] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  let token = store.getState().userAuth.userinfo.token;
  const { model, API, fileName, disabled } = props;
  // is Reponse blob type and json formate
  const isJsonBlob = (data) =>
    data instanceof Blob && data.type === "application/json";

  const DownloadExcelFile = () => {
    setLoader(true);
    let searchModal = model;
    searchModal.isExportCall = true;
    let myHeader = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer  " + token,
        Accept: "*/*",
      },
      responseType: "blob",
    };

    axios
      .post(API, searchModal, myHeader)
      .then(async (res) => {
        if (res) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, fileName);
          setConfirmation(false);
        } else {
          toast.error(NO_DATA_FOR_EXPORT);
        }
      })
      .catch(async (error) => {
        let errConfig = {
          statusCode: null,
          message: null,
        };

        if (error.response.status === 404) {
          errConfig = {
            message: "404 not found",
            statusCode: 404,
          };
          toast.error(errConfig.messasge);
          return;
        }
        const responseData = isJsonBlob(error.response?.data)
          ? await error.response?.data?.text()
          : error.response?.data || {};
        const responseJson =
          typeof responseData === "string"
            ? JSON.parse(responseData)
            : responseData;
        errConfig = {
          statusCode: responseJson.statusCode,
          message: responseJson.responseMessage,
        };
        toast.error(errConfig.message);
      })
      .finally(() => {
        setLoader(false);
        setConfirmation(false);
      });
  };

  return (
    <>
      {confirmation && (
        <ConfirmationPopup
          buttonTitle={"Yes"}
          onCancel={() => setConfirmation(false)}
          onConfirm={DownloadExcelFile}
          subHeading={props.subHeading ? `${props.subHeading}` : "Are you sure you want to download the document?"}
        />
      )}
      {loader && <FullPageLoader allowFullScreen />}
      <CustomButtonNew
        label="Download"
        disabled={disabled}
        variant="outline"
        color="secondary"
        onClick={() => setConfirmation(true)}
        prefixIcon={<DownloadIcon />}
        className='h-fit'
      />
    </>
  );
};
export default ExportExcel;
